import { HttpClient } from "@angular/common/http";
import { Store as AppStore } from "@ngrx/store";
import * as fromStore from "@store/state";

import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { AppState } from "@store/state";
import { AuthProtocol, BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse, User } from "@tendercuts/models";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
@Injectable()
export class CancelShiprocketService
  extends BasePostProvider<GenericServerResponse>
  implements AuthProtocol
{
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public store: AppStore<AppState>,
    public loginService: LoginServices
  ) {
    super(http);
  }

  getToken(): Observable<User> {
    return this.store.select(fromStore.getUser);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }

  get endpoint(): string {
    return this.endpointService.cancelShiprocket();
  }

  postProcessResponse(data: any): Array<any> {
    return this.data;
  }
}
